import { alpha, type PaletteOptions } from "@mui/material/styles";

import { colors } from "./colors.ts";

export const palette: PaletteOptions = {
  mode: "light",
  primary: {
    ...colors.primary,
    main: colors.primary[500],
    light: colors.primary[400],
    dark: colors.primary[700],
    contrastText: colors.white,
    _states: {
      hover: alpha(colors.primary[500], 0.04),
      selected: alpha(colors.primary[500], 0.08),
      focus: colors.primary.focus,
      focusVisible: alpha(colors.primary[500], 0.3),
      outlinedBorder: alpha(colors.primary[500], 0.5),
    },
  },
  secondary: {
    ...colors.softLavender,
    main: colors.softLavender[500],
    light: colors.softLavender[400],
    dark: colors.softLavender[700],
    contrastText: colors.darkCharcoal[900],
    _states: {
      hover: alpha(colors.softLavender[500], 0.04),
      selected: alpha(colors.softLavender[500], 0.08),
      focus: alpha(colors.softLavender[500], 0.12),
      focusVisible: alpha(colors.softLavender[500], 0.3),
      outlinedBorder: alpha(colors.softLavender[500], 0.5),
    },
  },
  action: {
    active: alpha(colors.blackAlpha[100], 0.56),
    hover: colors.action.hover,
    selected: alpha(colors.blackAlpha[100], 0.08),
    focus: alpha(colors.blackAlpha[100], 0.12),
    disabled: alpha(colors.blackAlpha[100], 0.38),
    disabledBackground: alpha(colors.blackAlpha[100], 0.12),
  },
  success: {
    ...colors.success,
    main: colors.success[500],
    dark: colors.success[700],
    light: colors.success[300],
    contrastText: colors.white,
    _states: {
      hover: alpha(colors.success[500], 0.04),
      selected: alpha(colors.success[500], 0.08),
      focus: alpha(colors.success[500], 0.12),
      focusVisible: alpha(colors.success[500], 0.3),
      outlinedBorder: alpha(colors.success[500], 0.5),
    },
  },
  info: {
    ...colors.information,
    main: colors.information[500],
    dark: colors.information[700],
    light: colors.information[300],
    contrastText: colors.white,
    _states: {
      hover: alpha(colors.information[500], 0.04),
      selected: alpha(colors.information[500], 0.08),
      focus: alpha(colors.information[500], 0.12),
      focusVisible: alpha(colors.information[500], 0.3),
      outlinedBorder: alpha(colors.information[500], 0.5),
    },
  },
  warning: {
    ...colors.warning,
    main: colors.warning[500],
    dark: colors.warning[700],
    light: colors.warning[300],
    contrastText: colors.darkCharcoal[900],
    _states: {
      hover: alpha(colors.warning[500], 0.04),
      selected: alpha(colors.warning[500], 0.08),
      focus: alpha(colors.warning[500], 0.12),
      focusVisible: alpha(colors.warning[500], 0.3),
      outlinedBorder: alpha(colors.warning[500], 0.5),
    },
  },
  error: {
    ...colors.error,
    main: colors.error[500],
    dark: colors.error[700],
    light: colors.error[300],
    contrastText: colors.white,
    _states: {
      hover: alpha(colors.error[500], 0.04),
      selected: alpha(colors.error[500], 0.08),
      focus: alpha(colors.error[500], 0.12),
      focusVisible: alpha(colors.error[500], 0.3),
      outlinedBorder: alpha(colors.error[500], 0.5),
    },
  },
  blackStates: {
    main: colors.blackAlpha[100],
    _states: {
      hover: alpha(colors.blackAlpha[100], 0.04),
      selected: alpha(colors.blackAlpha[100], 0.08),
      focus: alpha(colors.blackAlpha[100], 0.12),
      focusVisible: alpha(colors.blackAlpha[100], 0.3),
      outlinedBorder: alpha(colors.blackAlpha[100], 0.5),
    },
  },
  whiteStates: {
    main: colors.white,
    _states: {
      hover: alpha(colors.white, 0.04),
      selected: alpha(colors.white, 0.08),
      focus: alpha(colors.white, 0.12),
      focusVisible: alpha(colors.white, 0.3),
      outlinedBorder: alpha(colors.white, 0.5),
    },
  },
  softLavender: { ...colors.softLavender },
  darkCharcoal: { ...colors.darkCharcoal },
  coolGrey: { ...colors.coolGrey },
  information: { ...colors.information },
  gray: { ...colors.gray },
  amber: { ...colors.amber },
  indigo: { ...colors.indigo },
  blueGrey: { ...colors.blueGrey },
  cyan: { ...colors.cyan },
  deepOrange: { ...colors.deepOrange },
  deepPurple: { ...colors.deepPurple },
  lightBlue: { ...colors.lightBlue },
  lightGreen: { ...colors.lightGreen },
  lime: { ...colors.lime },
  orange: { ...colors.orange },
  pink: { ...colors.pink },
  purple: { ...colors.purple },
  teal: { ...colors.teal },
  yellow: { ...colors.yellow },
  text: {
    primary: colors.darkCharcoal[900],
    secondary: colors.coolGrey[700],
    disabled: colors.darkCharcoal[500],
  },
  grey: { ...colors.coolGrey },
  divider: colors.coolGrey[200],
  background: {
    default: colors.white,
    paper: colors.white,
  },
  components: {
    input: {
      outlined: {
        enabledBorder: colors.blackAlpha[23],
        hoverBorder: colors.blackAlpha[100],
      },
    },
  },
};
